import BaseDto from './BaseDto';

export default class DossierDto extends BaseDto {
  /**
   * Structure de la classe
   * @return {{dateNaissance: undefined, id: undefined, version: undefined, nom: undefined, prenom: undefined}}
   */
  get schema() { // eslint-disable-line
    return Object.assign(super.schema,
      {
        periodeFiscale: undefined,
        numeroAVS: undefined,
        noCollaborateur: undefined,
        nom: undefined,
        prenom: undefined,
        typeResident: undefined,
        adresseRue: undefined,
        adresseLocalite: undefined,
        isRevenuUnSeulEmployeur: undefined,
        etatCivil: undefined,
        hasEnfants: undefined,
        isMarie: undefined,
        hasConjointRevenu: undefined,
        isConjointFonctionnaireInt: undefined,
        typeFonctInt: undefined,
        remarques: [],
        sourceRevenu: [],
        isUnionLibre: undefined,
        isGardeAlternee: undefined,
        datesNaissanceEnfants: [{
          id: 1,
          dateNaissance: '',
        }],
        nbEnfants: undefined,
        isBaremeAjuste: undefined,
        bareme: undefined,
        isMessageBaremeH: undefined,
        canton: undefined,
        dateChangementEtatCivil: undefined,
        tauxGlobalActivite: undefined,
      });
  }

  /**
   * Fonction appelée en callback pour créer une nouvelle instance
   * @param inoJson Flux json
   * @return {DossierDto}
   */
  static getFactory(inoJson = {}) {
    return new DossierDto(inoJson);
  }
}
